export const NeumorphicCustomizationButton = (props) => {
  const selectedClass = "font-bold shadow-[2px_2px_0_0_#C2A899_inset] bg-canvas-depressed";
  const unselectedClass = "bg-canvas-light";

  return (
    <button
      class={`p-2 text-ink border border-secondary-500 text-sm ${props.selected ? selectedClass : unselectedClass}`}
      onClick={props.onClick}
      type="button">
      {props.label}
    </button>
  )
}